import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';

const SimplePopup = ({open, onClose, title, content, contentText, actions}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{sx: {padding: '1em 2em'}}}
    >
      <DialogTitle id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          { contentText}
        </DialogContentText>
        { content }
      </DialogContent>
      <DialogActions sx={{justifyContent: 'center'}}>
        {actions}
      </DialogActions>
    </Dialog>
  );
}

SimplePopup.propTypes = {
  open: PropTypes.func,
  onClose: PropTypes.func,
  title: PropTypes.string,
  content: PropTypes.string,
  contentText: PropTypes.string,
  actions: PropTypes.string
}

export default SimplePopup;
